var _g, _mask, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTargetPin = function SvgTargetPin(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 33,
    viewBox: "0 0 24 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_14729_13700)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 29,
    rx: 4,
    ry: 2,
    fill: "black",
    fillOpacity: 0.12
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_14729_13700",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 28,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1,
    y: 1,
    width: 22,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2C3.79086 2 2 3.79086 2 6V18C2 20.2091 3.79086 22 6 22H8.34589C9.64874 23.3224 10.8445 25.0501 11.2288 27.3195C11.2934 27.701 11.6131 27.997 12 27.997C12.3869 27.997 12.7066 27.701 12.7712 27.3195C13.1555 25.0501 14.3513 23.3224 15.6541 22H18C20.2091 22 22 20.2091 22 18V6C22 3.79086 20.2091 2 18 2H6Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2C3.79086 2 2 3.79086 2 6V18C2 20.2091 3.79086 22 6 22H8.34589C9.64874 23.3224 10.8445 25.0501 11.2288 27.3195C11.2934 27.701 11.6131 27.997 12 27.997C12.3869 27.997 12.7066 27.701 12.7712 27.3195C13.1555 25.0501 14.3513 23.3224 15.6541 22H18C20.2091 22 22 20.2091 22 18V6C22 3.79086 20.2091 2 18 2H6Z",
    fill: "#1A7D99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34589 22L9.05824 21.2982L8.76447 21H8.34589V22ZM11.2288 27.3195L10.2428 27.4865H10.2428L11.2288 27.3195ZM12.7712 27.3195L13.7572 27.4865H13.7572L12.7712 27.3195ZM15.6541 22V21H15.2355L14.9418 21.2982L15.6541 22ZM3 6C3 4.34315 4.34315 3 6 3V1C3.23858 1 1 3.23858 1 6H3ZM3 18V6H1V18H3ZM6 21C4.34315 21 3 19.6569 3 18H1C1 20.7614 3.23858 23 6 23V21ZM8.34589 21H6V23H8.34589V21ZM12.2147 27.1526C11.7851 24.6156 10.45 22.7108 9.05824 21.2982L7.63353 22.7018C8.84749 23.934 9.90382 25.4847 10.2428 27.4865L12.2147 27.1526ZM12 26.997C12.0686 26.997 12.1251 27.0246 12.1593 27.0551C12.1912 27.0836 12.2089 27.118 12.2147 27.1526L10.2428 27.4865C10.3809 28.3017 11.0789 28.997 12 28.997V26.997ZM11.7853 27.1526C11.7911 27.118 11.8088 27.0836 11.8407 27.0551C11.8749 27.0246 11.9314 26.997 12 26.997V28.997C12.9211 28.997 13.6191 28.3017 13.7572 27.4865L11.7853 27.1526ZM14.9418 21.2982C13.55 22.7108 12.2149 24.6156 11.7853 27.1526L13.7572 27.4865C14.0962 25.4847 15.1525 23.934 16.3665 22.7018L14.9418 21.2982ZM18 21H15.6541V23H18V21ZM21 18C21 19.6569 19.6569 21 18 21V23C20.7614 23 23 20.7614 23 18H21ZM21 6V18H23V6H21ZM18 3C19.6569 3 21 4.34315 21 6H23C23 3.23858 20.7614 1 18 1V3ZM6 3H18V1H6V3Z",
    fill: "url(#paint0_linear_14729_13700)",
    mask: "url(#path-2-outside-1_14729_13700)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5C10.613 5 9.4273 5.482 8.44296 6.446C7.48099 7.3881 7 8.53835 7 9.89672C7 10.5759 7.17897 11.3646 7.53691 12.2629C7.89485 13.1612 8.29195 13.9664 8.72819 14.6784C9.16443 15.3905 9.67338 16.1244 10.255 16.8803C10.8367 17.6362 11.2394 18.1401 11.4631 18.392C11.6868 18.644 11.8658 18.8466 12 19L12.5369 18.4413C12.8725 18.0469 13.2808 17.5156 13.7617 16.8474C14.2427 16.1792 14.7293 15.4617 15.2215 14.6948C15.7136 13.928 16.1331 13.1064 16.4799 12.23C16.8266 11.3537 17 10.5759 17 9.89671C17 8.53834 16.5134 7.38263 15.5403 6.42958C14.5671 5.47653 13.387 5 12 5ZM12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_14729_13700",
    x: 6,
    y: 25,
    width: 12,
    height: 8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_14729_13700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14729_13700",
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 27.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.35
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTargetPin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/target-pin.a1c97f226ebc72ab638b5ae0364d22ce.svg";